module.exports = __webpack_public_path__ + "img/formulario-metas.8184cad6.png";